// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--Fonts--*/
:root {
  --primary: #FF914E;
  --secondary: #07748F;
  --info: #343833;
  --white: #FFFFFF;
  --black: #000000;
  --liteblue: #e7f3f5;
  --shadeblue: #d1e6eb;
  --hrborder: #e4dede;
  --theader: #f5f7f8;
  --thinfo: #384648;
  --thborder: #dee2e6;
  --dlink: #007bff;
  --btninfo: #313232;
  --gary: #5a6e82;
  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);
  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);
  --red: #f15e48;
  --green: #02681a;
  --lowgray: #A0B2B5;
}

/* ---- font family ----*/
/*--- pixels --- */
/*---font size---*/
/*---font weight---*/
/*--- percentage ---*/
/*--- display ---*/
/*--- alignment ---*/
/*--Position --*/
/*--- Text Transform ---*/
/*-- Text Style --*/
/*-- Info and paragraph --*/
.font-common, .fr-to-search p, .addmarket p {
  font-size: 14px;
  color: var(--info);
  font-weight: 600;
}

/*--Flex-box--*/
.w-flex {
  width: 100%;
  display: flex;
}

/*-- Form Label--*/
.input-fonts, .inputfields, .fr-to-search .MuiGrid-grid-xs-3 .MuiFormControl-root input, .addmarket .MuiGrid-grid-xs-3 .MuiFormControl-root input, .formlabel {
  font-size: 11px;
  color: var(--black);
}

.formlabel {
  opacity: 1;
  margin-bottom: 0.3rem;
  margin-top: 5px;
  font-weight: 500;
}

.login-btn-hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-4, .heading-3, .heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext, .heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

.heading-4 {
  font-weight: 600;
  font-size: 25px;
  line-height: 26px;
}

.inputfields, .fr-to-search .MuiGrid-grid-xs-3 .MuiFormControl-root input, .addmarket .MuiGrid-grid-xs-3 .MuiFormControl-root input {
  height: 30px;
  line-height: 30px;
  opacity: 0.8;
  padding: 0px 0.5rem;
  background: #F4F6F7;
}

/*-- Box outer --*/
.boxing {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  padding: 15px 15px;
}

.login-btn-hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-1, .banner-bg-content .banner-container .banner-content h1, .heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext, .heading-3, .heading-4 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .card-content h4, .banner-bg-content .banner-container .banner-content .smalltext {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

/*--Buttons common--*/
.button-common, .secondary_button, .primary_button, .banner-bg-content .banner-container .banner-btn a {
  background: transparent !important;
  display: inline-block !important;
  padding: 8px 30px !important;
  height: 44px !important;
  border-radius: 50px !important;
  position: relative !important;
  transition: all 0.5s linear !important;
  text-align: center !important;
  vertical-align: middle !important;
  text-decoration: none !important;
  outline: 0px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 0px !important;
  cursor: pointer !important;
  text-transform: capitalize !important;
}

.link_button, .banner-bg-content .banner-container .banner-btn a {
  padding: 8px 40px !important;
  line-height: 1.5 !important;
  height: fit-content !important;
}

.primary, .secondary_button:hover, .primary_button, .banner-bg-content .banner-container .banner-btn a {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.secondary, .secondary_button, .primary_button:hover, .banner-bg-content .banner-container .banner-btn a:hover {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.stepper-next-btn:hover {
  border: 0px !important;
}

.primary_button span.MuiTouchRipple-root, .banner-bg-content .banner-container .banner-btn a span.MuiTouchRipple-root {
  display: none;
}

.secondary_button span.MuiTouchRipple-root {
  display: none;
}

.seeanalytics {
  padding: 8px 18px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  height: 33px !important;
}
.seeanalytics:hover, .seeanalytics:active, .seeanalytics:focus {
  background-color: var(--primary) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-comman {
  background: #fff;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}

.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card .h-op-features {
  font-weight: 600 !important;
  margin-bottom: 5px !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

/*--Fonts--*/
:root {
  --primary: #FF914E;
  --secondary: #07748F;
  --info: #343833;
  --white: #FFFFFF;
  --black: #000000;
  --liteblue: #e7f3f5;
  --shadeblue: #d1e6eb;
  --hrborder: #e4dede;
  --theader: #f5f7f8;
  --thinfo: #384648;
  --thborder: #dee2e6;
  --dlink: #007bff;
  --btninfo: #313232;
  --gary: #5a6e82;
  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);
  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);
  --red: #f15e48;
  --green: #02681a;
  --lowgray: #A0B2B5;
}

/* ---- font family ----*/
/*--- pixels --- */
/*---font size---*/
/*---font weight---*/
/*--- percentage ---*/
/*--- display ---*/
/*--- alignment ---*/
/*--Position --*/
/*--- Text Transform ---*/
/*-- Text Style --*/
/*-- Info and paragraph --*/
.font-common, .fr-to-search p, .addmarket p {
  font-size: 14px;
  color: var(--info);
  font-weight: 600;
}

/*--Flex-box--*/
.w-flex {
  width: 100%;
  display: flex;
}

/*-- Form Label--*/
.input-fonts, .formlabel, .inputfields, .fr-to-search .MuiGrid-grid-xs-3 .MuiFormControl-root input, .addmarket .MuiGrid-grid-xs-3 .MuiFormControl-root input {
  font-size: 11px;
  color: var(--black);
}

.formlabel {
  opacity: 1;
  margin-bottom: 0.3rem;
  margin-top: 5px;
  font-weight: 500;
}

.login-btn-hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-1, .heading-2, .heading-3, .heading-4, .banner-bg-content .banner-container .banner-content .smalltext, .banner-bg-content .banner-container .banner-content h1, .card-content h4 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .banner-bg-content .banner-container .banner-content .smalltext, .card-content h4 {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

.heading-4 {
  font-weight: 600;
  font-size: 25px;
  line-height: 26px;
}

.inputfields, .fr-to-search .MuiGrid-grid-xs-3 .MuiFormControl-root input, .addmarket .MuiGrid-grid-xs-3 .MuiFormControl-root input {
  height: 30px;
  line-height: 30px;
  opacity: 0.8;
  padding: 0px 0.5rem;
  background: #F4F6F7;
}

/*-- Box outer --*/
.boxing {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  padding: 15px 15px;
}

.login-btn-hover {
  color: var(--primary);
  background-position: left;
  fill: var(--primary) !important;
}

.heading-comman, .heading-1, .heading-2, .heading-3, .heading-4, .banner-bg-content .banner-container .banner-content .smalltext, .banner-bg-content .banner-container .banner-content h1, .card-content h4 {
  font-style: normal;
  font-weight: 700;
}

.heading-1, .banner-bg-content .banner-container .banner-content h1 {
  font-size: 43px;
  line-height: 62px;
  margin-bottom: 25px;
}

.heading-2, .banner-bg-content .banner-container .banner-content .smalltext, .card-content h4 {
  font-size: 35px;
  line-height: 50px;
}

.heading-3 {
  font-size: 30px;
  line-height: 60px;
  margin-bottom: 15px;
}

/*--Buttons common--*/
.button-common, .primary_button, .secondary_button, .banner-bg-content .banner-container .banner-btn a {
  background: transparent !important;
  display: inline-block !important;
  padding: 8px 30px !important;
  height: 44px !important;
  border-radius: 50px !important;
  position: relative !important;
  transition: all 0.5s linear !important;
  text-align: center !important;
  vertical-align: middle !important;
  text-decoration: none !important;
  outline: 0px !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 0px !important;
  cursor: pointer !important;
  text-transform: capitalize !important;
}

.link_button, .banner-bg-content .banner-container .banner-btn a {
  padding: 8px 40px !important;
  line-height: 1.5 !important;
  height: fit-content !important;
}

.primary, .primary_button, .secondary_button:hover, .banner-bg-content .banner-container .banner-btn a {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.secondary, .primary_button:hover, .secondary_button, .banner-bg-content .banner-container .banner-btn a:hover {
  border: 3px solid var(--primary) !important;
  background-color: var(--primary) !important;
  color: var(--white) !important;
  box-shadow: none !important;
}

.stepper-next-btn:hover {
  border: 0px !important;
}

.primary_button span.MuiTouchRipple-root, .banner-bg-content .banner-container .banner-btn a span.MuiTouchRipple-root {
  display: none;
}

.secondary_button span.MuiTouchRipple-root {
  display: none;
}

.seeanalytics {
  padding: 8px 18px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  height: 33px !important;
}
.seeanalytics:hover, .seeanalytics:active, .seeanalytics:focus {
  background-color: var(--primary) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

.btn-wid, .banner-bg-content .banner-container .banner-btn a {
  padding: 10px 40px !important;
  margin-top: 25px;
  margin-right: 13px;
}

/* --banner-style-- */
.banner-bg-content .banner-container {
  padding-top: 30px;
  padding-bottom: 30px;
  min-height: 585px;
}
.banner-bg-content .banner-container .banner-content {
  padding: 0px;
  color: var(--white);
  font-style: normal;
}
.banner-bg-content .banner-container .banner-content .smalltext {
  font-weight: 600 !important;
  line-height: 68px !important;
  color: #07748f !important;
  margin-bottom: 0 !important;
  margin-top: 17px !important;
}
.banner-bg-content .banner-container .banner-content p {
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 1rem;
}
.banner-bg-content .banner-container .banner-img img {
  width: 119%;
  position: relative;
  top: -10px;
  left: 74px;
  height: auto;
}
.banner-bg-content .banner-container .banner-btn a {
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3);
}
.banner-bg-content .banner-container .banner-btn a:nth-child(2) {
  background-color: transparent !important;
  border: 2px solid var(--white) !important;
}
.banner-bg-content .banner-container .banner-btn a:hover {
  box-shadow: none;
}

/* -- card-style -- */
.card-comman {
  background: #fff;
  box-shadow: 0 4px 40px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}

.card-content {
  background-color: rgba(7, 116, 143, 0.05);
}
.card-content h4 {
  margin-bottom: 40px;
}
.card-content .section-card {
  width: 100%;
  margin-left: auto;
  display: block;
  height: 105px;
  background: var(--white);
  box-shadow: 0 4px 20px rgba(23, 125, 150, 0.2);
  border-radius: 20px;
  padding: 10px 18px 10px 6px;
  margin-bottom: 25px;
  transition: all 0.5s ease-in-out;
  flex-direction: unset !important;
}
.card-content .section-card .h-op-features {
  font-weight: 600 !important;
  margin-bottom: 5px !important;
}
.card-content .section-card p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  margin-left: 10px;
}
.card-content .section-card:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, 0.3) !important;
}

/* search route base form style */
.fr-to-search, .addmarket {
  padding: 1.25rem;
}
.fr-to-search p, .addmarket p {
  font-weight: 500;
  margin-bottom: 10px;
}
.fr-to-search .MuiGrid-grid-xs-3 .MuiFormControl-root, .addmarket .MuiGrid-grid-xs-3 .MuiFormControl-root {
  width: 100%;
  padding-right: 17px;
}
.fr-to-search .MuiGrid-grid-xs-3 .MuiFormControl-root input, .addmarket .MuiGrid-grid-xs-3 .MuiFormControl-root input {
  font-size: 13px;
  height: 35px;
  border: 1px solid #d9d9d9 !important;
  border-radius: 4px;
}
.fr-to-search button, .addmarket button, .fr-to-search button.secondary_button {
  border-radius: 3px !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  height: 37px !important;
}

.addmarket h1,
.addmarket p {
  margin-bottom: 8px;
  line-height: 1.2;
}
.addmarket .MuiGrid-grid-xs-2 {
  display: flex !important;
  justify-content: flex-start !important;
}

.font-p, .shop-stepper .MuiStepLabel-label.MuiStepLabel-alternativeLabel, .shop-stepper .Mui-disabled svg text, .shop-stepper svg text.MuiStepIcon-text, .shop-stepper .MuiStepIcon-completed-cx .MuiStepLabel-alternativeLabel {
  font-size: 12px !important;
  font-weight: 500;
}

/*-- Stepper --*/
.shop-stepper .MuiStepIcon-completed-cx svg circle {
  fill: var(--primary) !important;
}
.shop-stepper .MuiStep-root:nth-child(2) .MuiStepConnector-root.Mui-active .MuiStepConnector-lineHorizontal,
.shop-stepper .MuiStep-root:nth-child(2) .MuiStepConnector-root.Mui-completed .MuiStepConnector-lineHorizontal,
.shop-stepper .MuiStep-root:nth-child(3) .MuiStepConnector-root.Mui-active .MuiStepConnector-lineHorizontal {
  border-color: var(--primary);
}
.shop-stepper .MuiStepIcon-completed-cx svg text {
  fill: var(--white) !important;
}
.shop-stepper .MuiStepIcon-completed-cx .MuiStepLabel-alternativeLabel {
  color: rgba(0, 0, 0, 0.87) !important;
}
.shop-stepper .MuiStepLabel-root .MuiStepLabel-alternativeLabel svg.MuiSvgIcon-root {
  width: 33px;
  height: 33px !important;
  background: var(--primary);
  border-radius: 50%;
  margin: 0;
  border: 2px solid var(--primary);
  color: var(--white);
}
.shop-stepper .MuiStepIcon-root.MuiStepIcon-active {
  color: var(--primary);
}
.shop-stepper .MuiStepIcon-root.MuiStepIcon-active text {
  fill: var(--white);
}
.shop-stepper .MuiStepIcon-root.MuiStepIcon-active circle {
  fill: var(--primary);
}
.shop-stepper svg text.MuiStepIcon-text {
  fill: var(--primary);
}
.shop-stepper .MuiStepConnector-lineHorizontal {
  border-top-width: 6px;
  margin-top: 2px;
  border-color: #fdeeec;
  z-index: 0;
}
.shop-stepper .MuiStepConnector-alternativeLabel {
  top: 11px;
  left: calc(-50% + 8px);
  right: calc(50% + 8px);
}
.shop-stepper .MuiStepLabel-iconContainer {
  z-index: 1;
}
.shop-stepper .Mui-disabled svg circle {
  fill: var(--white);
}
.shop-stepper .Mui-disabled svg text {
  fill: var(--primary);
}
.shop-stepper .MuiStepIcon-root.MuiStepIcon-completed {
  color: var(--primary);
}
.shop-stepper .MuiStepConnector-active .MuiStepConnector-lineHorizontal, .shop-stepper .MuiStepConnector-completed .MuiStepConnector-lineHorizontal {
  border-color: var(--primary);
}
.shop-stepper .MuiStepLabel-label.MuiStepLabel-alternativeLabel {
  font-size: 15px !important;
  margin-top: 5px;
}
.shop-stepper .MuiStepper-root {
  display: flex;
  padding: 0px 24px 24px;
}
.shop-stepper .Mui-disabled .MuiStepLabel-labelContainer .MuiStepLabel-alternativeLabel {
  color: var(--black);
  opacity: 0.5;
}

/*-- Stepper Common Values --*/
.addmarketstepper form {
  padding: 0px 7px;
}
.addmarketstepper form .MuiGrid-root p.MuiFormHelperText-root {
  font-size: 11px !important;
}
.addmarketstepper label.MuiFormLabel-root {
  font-size: 13px;
  font-weight: 500;
  color: #212529;
  line-height: 1.5;
}
.addmarketstepper .checkbox-input .MuiFormGroup-root label.MuiFormControlLabel-root {
  margin-bottom: 0.5em;
}
.addmarketstepper .checkbox-input .MuiFormGroup-root label.MuiFormControlLabel-root span.MuiButtonBase-root {
  padding: 0px;
}
.addmarketstepper .checkbox-input .MuiFormGroup-root label.MuiFormControlLabel-root span.MuiTypography-root {
  font-weight: 400;
  color: #7b7b7b;
  font-size: 13px;
  margin-left: 5px;
}
.addmarketstepper .checkbox-input .MuiFormGroup-root label.MuiFormControlLabel-root.Mui-disabled .MuiCheckbox-root {
  opacity: 0.5;
  cursor: no-drop;
}

.stepper-btn {
  justify-content: space-between;
  display: flex;
}
.stepper-btn button.secondary_button.clear-background {
  background: transparent !important;
  color: #313232 !important;
  border: 1px solid #313232 !important;
  margin-right: 15px !important;
}

.stepper-first-btn {
  justify-content: end;
}

.flightshopdetails .secondary_button, .stepper-btn .secondary_button {
  border-radius: 2px !important;
  height: 33px !important;
  line-height: 33px !important;
  font-size: 14px !important;
  padding: 0px 35px !important;
  font-weight: 400 !important;
  border: 0px !important;
}

.searchinput-box {
  width: 280px;
  height: calc(1.5em + 0.5rem + 2px);
  padding: 5px 10px;
  font-weight: 300;
  font-size: 13px;
  border: 1px solid #aaa;
  border-radius: 4px;
  margin: 1px 10px 12px -11px;
  background: #F4F6F7;
}

.source-dropdown .MuiFormGroup-root, .source-dropdown .check-field-box {
  width: 85%;
  overflow-y: auto;
  max-height: 200px;
  margin-left: -10px;
  flex-wrap: nowrap;
  padding: 5px 7px;
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  margin-bottom: 12px;
}
.source-dropdown .MuiFormGroup-root label.MuiFormControlLabel-root, .source-dropdown .check-field-box label.MuiFormControlLabel-root {
  margin-left: 0px !important;
}

.select-box-stepper .MuiFormControl-root {
  width: 95%;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.select-box-stepper .MuiFormControl-root .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
  width: 100%;
}
.select-box-stepper .MuiSelect-select, .select-box-stepper .select-dropdown {
  height: 33px;
  color: #7b7b7b;
  padding: 0.2rem 0.75rem;
  width: 95%;
  font-size: 13px !important;
  box-shadow: none !important;
  border: 1px solid #ced4da !important;
  border-radius: 0.2rem;
  text-transform: none !important;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.select-box-stepper .MuiSelect-select span svg, .select-box-stepper .select-dropdown span svg {
  margin-top: 5px !important;
}

.volatility-airline .css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper, .volatility-airline .MuiMenu-paper {
  width: 15%;
}
.volatility-airline .css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper ul li span, .volatility-airline .MuiMenu-paper ul li span {
  margin-right: 5px !important;
}
.volatility-airline .css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper ul li .MuiListItemText-root span, .volatility-airline .MuiMenu-paper ul li .MuiListItemText-root span {
  font-size: 11px !important;
  font-weight: 500;
  word-break: break-all;
}

.check-field-box .MuiFormHelperText-root {
  margin-bottom: 0px !important;
  margin-left: 0.7rem;
}
.check-field-box p {
  margin-bottom: 1rem !important;
}
.check-field-box p .learnmore-link {
  margin-left: 0.7rem;
  font-size: 11px;
  text-decoration: underline;
}

.num-stop-box {
  display: flex;
  align-items: center;
}
.num-stop-box input {
  margin-right: 2px;
}
.num-stop-box label {
  margin-left: 5px;
  margin-right: 15px;
}

.switch-button {
  display: inline-block;
  position: relative;
  top: -6px;
  margin-right: 10px;
}
.switch-button label {
  display: flex;
  align-items: center;
}
.switch-button label svg {
  color: #fff;
  position: relative;
  left: -1px;
}
.switch-button label i {
  color: #fff !important;
  text-decoration: none !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  font-size: 13px;
  background: transparent;
  border: none;
  outline: 0px;
  padding: 5px 5px 5px 5px;
  font-style: normal;
  position: relative;
  top: -1px;
}

#swtoggle label i {
  color: #7B7B7B !important;
  font-weight: 400 !important;
  top: 7px !important;
  padding-left: 10px !important;
}

#swtoggle .backgroundset {
  padding: 0px !important;
}

#swtoggle .switch {
  top: 7px !important;
}

#swtoggle input:checked + .slider {
  background-color: #FF914E !important;
}

#swtoggle input:focus + .slider {
  box-shadow: 0 0 1px #FF914E !important;
}

.backgroundset {
  background-color: #fff;
  padding: 2px 3px;
  border-radius: 2px;
}

.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 18px;
  top: 3px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgb(136, 136, 136);
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 14px;
  width: 14px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: rgb(0, 136, 0);
}

input:focus + .slider {
  box-shadow: 0 0 1px rgb(0, 136, 0);
}

input:checked + .slider:before {
  transform: translateX(16px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.btn-swap-css {
  display: flex !important;
  align-items: center;
  justify-content: center;
  text-align: center !important;
  vertical-align: middle !important;
  height: 37px !important;
  line-height: 37px !important;
  cursor: pointer;
}
.btn-swap-css svg {
  margin-top: -3px !important;
  height: 0.9em !important;
  line-height: 37px !important;
  display: block !important;
  color: #fff !important;
}

@media (min-width: 280px) and (max-width: 991.5px) {
  #createMmarketResponsive {
    display: flex !important;
    flex-direction: column !important;
    margin: 0px !important;
  }
  #createMmarketResponsive .MuiGrid-grid-xs-3, #createMmarketResponsive .MuiGrid-grid-xs-2, #createMmarketResponsive .MuiGrid-grid-xs-1 {
    width: 100% !important;
    padding: 0px !important;
    max-width: 100% !important;
    flex-basis: 100% !important;
  }
  #createMmarketResponsive .from-input-filed .MuiTextField-root, #createMmarketResponsive .to-input-filed .MuiTextField-root {
    padding: 0px 0px 10px !important;
  }
  #createMmarketResponsive .MuiGrid-grid-xs-1 button {
    margin: auto !important;
  }
  #createMmarketResponsive .MuiGrid-grid-xs-1 .btn-swap-css {
    margin: auto !important;
    margin-right: auto !important;
    margin-bottom: 10px !important;
    width: fit-content !important;
  }
}
.rate-parity-label {
  margin-bottom: 15px !important;
}
.rate-parity-label label {
  margin-left: 0px;
}
.rate-parity-label label .MuiTypography-root {
  color: #212529 !important;
  font-weight: 500 !important;
  line-height: 1.5;
}

.MuiTextField-root {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

#createMmarketResponsive .MuiFormControl-root input {
  padding: 0px 8px !important;
}

.flex-radiobox .MuiFormGroup-root {
  flex-direction: row;
}
.flex-radiobox .MuiFormGroup-root .MuiTypography-root {
  font-size: 13px;
  color: #7b7b7b;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/pages/dynamic/add-flight-shop/addmarket.scss","webpack://./src/pages/dynamic/searchform.scss"],"names":[],"mappings":"AAAA,YAAA;AAIA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kEAAA;EACA,yDAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ACEF;;ADCA,yBAAA;AAIA,kBAAA;AAsFA,kBAAA;AAqCA,oBAAA;AASA,qBAAA;AAmBA,kBAAA;AAYA,oBAAA;AAaA,gBAAA;AAKA,yBAAA;AAMA,mBAAA;AAGA,2BAAA;AACA;EACE,eAhLM;EAiLN,kBAAA;EACA,gBAnEM;ACnHR;;ADyLA,eAAA;AACA;EACE,WAnDQ;EAoDR,aAhDK;ACtIP;;ADyLA,kBAAA;AACA;EACE,eAjMM;EAkMN,mBAAA;ACtLF;;ADyLA;EAEE,UAAA;EACA,qBAAA;EACA,eA/MK;EAgNL,gBAxFM;AC/FR;;AD0LA;EACE,qBAAA;EACA,yBAtDK;EAuDL,+BAAA;ACvLF;;AD0LA;EACE,kBApCO;EAqCP,gBAAA;ACvLF;;AD0LA;EACE,eAxLM;EAyLN,iBAtKM;EAuKN,mBA5MM;ACqBR;;AD2LA;EACE,eAvMM;EAwMN,iBAzLM;ACCR;;AD4LA;EACE,eAlNM;EAmNN,iBArLM;EAsLN,mBAnOM;AC0CR;;AD6LA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AC1LF;;AD8LA;EAEE,YAjOM;EAkON,iBAlOM;EAmON,YAAA;EACA,mBAAA;EACA,mBAAA;AC5LF;;AD+LA,kBAAA;AACA;EACE,kBAzFS;EA0FT,aAnHK;EAoHL,sBAjGO;EAkGP,YAAA;EACA,qBAlGU;EAmGV,8BAAA;EACA,2BAnGU;EAoGV,sCAAA;EACA,sBAAA;EACA,mDAAA;EACA,kBAAA;AC5LF;;AD+LA;EACE,qBAAA;EACA,yBApHK;EAqHL,+BAAA;AC5LF;;AD+LA;EACE,kBAlGO;EAmGP,gBAAA;AC5LF;;AD+LA;EACE,eAtPM;EAuPN,iBApOM;EAqON,mBA1QM;AC8ER;;ADgMA;EACE,eArQM;EAsQN,iBAvPM;AC0DR;;ADiMA;EACE,eAhRM;EAiRN,iBAnPM;EAoPN,mBAjSM;ACmGR;;ADkMA,qBAAA;AACA;EACE,kCAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EACA,6BAAA;EACA,iCAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,qCAAA;AC/LF;;ADkMA;EACE,4BAAA;EACA,2BAAA;EACA,8BAAA;AC/LF;;ADkMA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;AC/LF;;ADkMA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;AC/LF;;ADiMA;EACE,sBAAA;AC9LF;;ADyME;EACE,aAAA;ACtMJ;;ADkNE;EACE,aAAA;AC/MJ;;ADkNA;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;AC/MF;ADgNE;EACE,2CAAA;AC9MJ;;ADkNA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;AC/MF;;ADkNA,qBAAA;AAEE;EACE,iBA7WI;EA8WJ,oBA9WI;EA+WJ,iBAAA;AChNJ;ADkNI;EACE,YAjZC;EAkZD,mBAAA;EACA,kBAxNG;ACQT;ADkNM;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AChNR;ADwNM;EACE,gBAvSA;EAwSA,eA/YA;EAgZA,iBAtYA;EAuYA,mBAAA;ACtNR;AD2NM;EACE,WAAA;EACA,kBA7PG;EA8PH,UAAA;EACA,UAAA;EACA,YAtRD;AC6DP;AD8NM;EAEE,oDAAA;AC7NR;AD+NQ;EACE,wCAAA;EACA,yCAAA;AC7NV;ADmOQ;EACE,gBArSH;ACoEP;;ADwOA,qBAAA;AACA;EACE,yCAAA;ACrOF;ADuOE;EACE,mBAraI;ACgMR;ADyOE;EACE,WAhUM;EAiUN,iBA1TG;EA2TH,cA7TI;EA8TJ,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBApcI;EAqcJ,2BAAA;EACA,mBAjcI;EAkcJ,gCAAA;EACA,gCAAA;ACvOJ;ADyOI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ACvON;AD0OI;EACE,sBAAA;EACA,+DAAA;ACxON;;AD6OE;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;AC1OJ;;AD6OE,qBAAA;AAEE;EACE,iBAzdE;EA0dF,oBA1dE;EA2dF,iBAAA;AC3ON;AD6OM;EACE,YA7fD;EA8fC,mBAAA;EACA,kBApUC;ACyFT;AD6OQ;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AC3OV;ADmPQ;EACE,gBAnZF;EAoZE,eA3fF;EA4fE,iBAlfF;EAmfE,mBAAA;ACjPV;ADsPQ;EACE,WAAA;EACA,kBAzWC;EA0WD,UAAA;EACA,UAAA;EACA,YAlYH;AC8IP;ADyPQ;EAEE,oDAAA;ACxPV;AD0PU;EACE,wCAAA;EACA,yCAAA;ACxPZ;AD8PU;EACE,gBAjZL;ACqJP;;ADmQE,qBAAA;AACA;EACE,gBAAA;EACA,yCAAA;EACA,mBAAA;AChQJ;;ADmQE;EACE,yCAAA;AChQJ;ADkQI;EACE,mBAvhBE;ACuRR;ADoQI;EACE,WAlbI;EAmbJ,iBA5aC;EA6aD,cA/aE;EAgbF,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBAtjBE;EAujBF,2BAAA;EACA,mBAnjBE;EAojBF,gCAAA;EACA,gCAAA;AClQN;ADoQM;EACE,2BAAA;EACA,6BAAA;AClQR;ADqQM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ACnQR;ADsQM;EACE,sBAAA;EACA,+DAAA;ACpQR;;AD5XA,YAAA;AAIA;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,kEAAA;EACA,yDAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AC4XF;;ADzXA,yBAAA;AAIA,kBAAA;AAsFA,kBAAA;AAqCA,oBAAA;AASA,qBAAA;AAmBA,kBAAA;AAYA,oBAAA;AAaA,gBAAA;AAKA,yBAAA;AAMA,mBAAA;AAGA,2BAAA;AACA;EACE,eAhLM;EAiLN,kBAAA;EACA,gBAnEM;ACuQR;;ADjMA,eAAA;AACA;EACE,WAnDQ;EAoDR,aAhDK;ACoPP;;ADjMA,kBAAA;AACA;EACE,eAjMM;EAkMN,mBAAA;ACoMF;;ADjMA;EAEE,UAAA;EACA,qBAAA;EACA,eA/MK;EAgNL,gBAxFM;AC2RR;;ADhMA;EACE,qBAAA;EACA,yBAtDK;EAuDL,+BAAA;ACmMF;;ADhMA;EACE,kBApCO;EAqCP,gBAAA;ACmMF;;ADhMA;EACE,eAxLM;EAyLN,iBAtKM;EAuKN,mBA5MM;AC+YR;;AD/LA;EACE,eAvMM;EAwMN,iBAzLM;AC2XR;;AD9LA;EACE,eAlNM;EAmNN,iBArLM;EAsLN,mBAnOM;ACoaR;;AD7LA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;ACgMF;;AD5LA;EAEE,YAjOM;EAkON,iBAlOM;EAmON,YAAA;EACA,mBAAA;EACA,mBAAA;AC8LF;;AD3LA,kBAAA;AACA;EACE,kBAzFS;EA0FT,aAnHK;EAoHL,sBAjGO;EAkGP,YAAA;EACA,qBAlGU;EAmGV,8BAAA;EACA,2BAnGU;EAoGV,sCAAA;EACA,sBAAA;EACA,mDAAA;EACA,kBAAA;AC8LF;;AD3LA;EACE,qBAAA;EACA,yBApHK;EAqHL,+BAAA;AC8LF;;AD3LA;EACE,kBAlGO;EAmGP,gBAAA;AC8LF;;AD3LA;EACE,eAtPM;EAuPN,iBApOM;EAqON,mBA1QM;ACwcR;;AD1LA;EACE,eArQM;EAsQN,iBAvPM;ACobR;;ADzLA;EACE,eAhRM;EAiRN,iBAnPM;EAoPN,mBAjSM;AC6dR;;ADxLA,qBAAA;AACA;EACE,kCAAA;EACA,gCAAA;EACA,4BAAA;EACA,uBAAA;EACA,8BAAA;EACA,6BAAA;EACA,sCAAA;EACA,6BAAA;EACA,iCAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,2BAAA;EACA,0BAAA;EACA,qCAAA;AC2LF;;ADxLA;EACE,4BAAA;EACA,2BAAA;EACA,8BAAA;AC2LF;;ADxLA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;AC2LF;;ADxLA;EACE,2CAAA;EACA,2CAAA;EACA,8BAAA;EACA,2BAAA;AC2LF;;ADzLA;EACE,sBAAA;AC4LF;;ADjLE;EACE,aAAA;ACoLJ;;ADxKE;EACE,aAAA;AC2KJ;;ADxKA;EACE,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;AC2KF;AD1KE;EACE,2CAAA;AC4KJ;;ADxKA;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;AC2KF;;ADxKA,qBAAA;AAEE;EACE,iBA7WI;EA8WJ,oBA9WI;EA+WJ,iBAAA;AC0KJ;ADxKI;EACE,YAjZC;EAkZD,mBAAA;EACA,kBAxNG;ACkYT;ADxKM;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AC0KR;ADlKM;EACE,gBAvSA;EAwSA,eA/YA;EAgZA,iBAtYA;EAuYA,mBAAA;ACoKR;AD/JM;EACE,WAAA;EACA,kBA7PG;EA8PH,UAAA;EACA,UAAA;EACA,YAtRD;ACubP;AD5JM;EAEE,oDAAA;AC6JR;AD3JQ;EACE,wCAAA;EACA,yCAAA;AC6JV;ADvJQ;EACE,gBArSH;AC8bP;;ADlJA,qBAAA;AACA;EACE,yCAAA;ACqJF;ADnJE;EACE,mBAraI;AC0jBR;ADjJE;EACE,WAhUM;EAiUN,iBA1TG;EA2TH,cA7TI;EA8TJ,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBApcI;EAqcJ,2BAAA;EACA,mBAjcI;EAkcJ,gCAAA;EACA,gCAAA;ACmJJ;ADjJI;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ACmJN;ADhJI;EACE,sBAAA;EACA,+DAAA;ACkJN;;AD7IE;EACE,6BAAA;EACA,gBAAA;EACA,kBAAA;ACgJJ;;AD7IE,qBAAA;AAEE;EACE,iBAzdE;EA0dF,oBA1dE;EA2dF,iBAAA;AC+IN;AD7IM;EACE,YA7fD;EA8fC,mBAAA;EACA,kBApUC;ACmdT;AD7IQ;EACE,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;AC+IV;ADvIQ;EACE,gBAnZF;EAoZE,eA3fF;EA4fE,iBAlfF;EAmfE,mBAAA;ACyIV;ADpIQ;EACE,WAAA;EACA,kBAzWC;EA0WD,UAAA;EACA,UAAA;EACA,YAlYH;ACwgBP;ADjIQ;EAEE,oDAAA;ACkIV;ADhIU;EACE,wCAAA;EACA,yCAAA;ACkIZ;AD5HU;EACE,gBAjZL;AC+gBP;;ADvHE,qBAAA;AACA;EACE,gBAAA;EACA,yCAAA;EACA,mBAAA;AC0HJ;;ADvHE;EACE,yCAAA;AC0HJ;ADxHI;EACE,mBAvhBE;ACipBR;ADtHI;EACE,WAlbI;EAmbJ,iBA5aC;EA6aD,cA/aE;EAgbF,aAAA;EACA,wBAAA;EACA,8CAAA;EACA,mBAtjBE;EAujBF,2BAAA;EACA,mBAnjBE;EAojBF,gCAAA;EACA,gCAAA;ACwHN;ADtHM;EACE,2BAAA;EACA,6BAAA;ACwHR;ADrHM;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;ACuHR;ADpHM;EACE,sBAAA;EACA,+DAAA;ACsHR;;ACpvBA,iCAAA;AACA;EACI,gBAAA;ADuvBJ;ACtvBI;EAEI,gBFqJA;EEpJA,mBFiCA;ACstBR;ACpvBQ;EACI,WAAA;EACA,mBFoCJ;ACktBR;ACrvBY;EAEI,eF6BR;EE5BQ,YFkDR;EEjDQ,oCAAA;EACA,kBAAA;ADsvBhB;AClvBI;EACI,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;ADovBR;;AA3wBI;;EAEI,kBDiCD;EChCC,gBAAA;AA8wBR;AA3wBI;EACI,wBAAA;EACA,sCAAA;AA6wBR;;AAxwBA;EACI,0BAAA;EACA,gBDyII;ACkoBR;;AAzwBA,gBAAA;AAEI;EACE,+BAAA;AA2wBN;AAzwBI;;;EAGE,4BAAA;AA2wBN;AAzwBI;EACE,6BAAA;AA2wBN;AAxwBI;EACE,qCAAA;AA0wBN;AAtwBI;EACE,WDwBE;ECvBF,uBAAA;EACA,0BAAA;EACA,kBDgIG;EC/HH,SAAA;EACA,gCAAA;EACA,mBAAA;AAwwBN;AArwBI;EACE,qBAAA;AAuwBN;AApwBI;EACE,kBAAA;AAswBN;AAnwBI;EACE,oBAAA;AAqwBN;AAlwBI;EAEE,oBAAA;AAmwBN;AAhwBI;EACE,qBD/BC;ECgCD,eDpCC;ECqCD,qBAAA;EACA,UAAA;AAkwBN;AA/vBI;EACE,SDjCE;ECkCF,sBAAA;EACA,sBAAA;AAiwBN;AA9vBI;EACE,UAAA;AAgwBN;AA5vBM;EACE,kBAAA;AA8vBR;AA3vBM;EACE,oBAAA;AA6vBR;AAxvBI;EACE,qBAAA;AA0vBN;AAtvBM;EACE,4BAAA;AAwvBR;AApvBI;EAEE,0BAAA;EACA,eDxEC;AC6zBP;AAlvBI;EACI,aDsED;ECrEC,sBAAA;AAovBR;AA/uBQ;EACE,mBAAA;EACA,YAAA;AAivBV;;AA3uBE,8BAAA;AAEE;EACI,gBAAA;AA6uBR;AA3uBQ;EACE,0BAAA;AA6uBV;AAzuBI;EACI,eD5FA;EC6FA,gBDkBA;ECjBA,cAAA;EACA,gBAAA;AA2uBR;AAvuBQ;EACE,oBAAA;AAyuBV;AAxuBU;EACE,YDpHL;AC81BP;AAxuBU;EACE,gBDKJ;ECJI,cAAA;EACA,eD3GJ;EC4GI,gBDrHL;AC+1BP;AAtuBU;EACE,YAAA;EACA,eAAA;AAwuBZ;;AAluBE;EACE,8BDkCY;ECjCZ,aDeG;ACstBP;AApuBI;EACE,kCAAA;EACA,yBAAA;EACA,oCAAA;EACA,6BAAA;AAsuBN;;AAnuBE;EACE,oBD4BE;AC0sBN;;AAnuBI;EACE,6BAAA;EACA,uBAAA;EACA,4BAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;AAsuBN;;AAnuBE;EACE,YAAA;EACA,kCAAA;EACA,iBAAA;EACA,gBDvCI;ECwCJ,eDrJI;ECsJJ,sBAAA;EACA,kBDjKG;ECkKH,2BAAA;EACA,mBAAA;AAsuBJ;;AAnuBI;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAsuBN;AAruBI;EACE,2BAAA;AAuuBN;;AAluBI;EACE,UAAA;EACA,0BAAA;EACA,6BAAA;AAquBN;AApuBM;EACE,WAAA;AAsuBR;AAnuBI;EACE,YAAA;EACA,cAAA;EACA,uBAAA;EACA,UAAA;EACA,0BAAA;EACA,2BAAA;EACA,oCAAA;EACA,qBAAA;EACA,+BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAquBN;AAnuBQ;EACE,0BAAA;AAquBV;;AA/tBI;EACE,UAAA;AAkuBN;AA/tBU;EACE,4BAAA;AAiuBZ;AA9tBY;EACE,0BAAA;EACA,gBAAA;EACA,qBAAA;AAguBd;;AAvtBI;EACE,6BAAA;EACA,mBAAA;AA0tBN;AAxtBI;EACE,8BAAA;AA0tBN;AAztBM;EACE,mBAAA;EACJ,eAAA;EACA,0BAAA;AA2tBJ;;AAvtBE;EACE,aAAA;EACA,mBAAA;AA0tBJ;AAztBI;EACE,iBAAA;AA2tBN;AAxtBI;EACE,gBAAA;EACA,kBAAA;AA0tBN;;AAvtBE;EACE,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AA0tBJ;AAztBI;EAKE,aAAA;EACA,mBAAA;AAutBN;AAttBM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;AAwtBR;AAttBM;EACE,sBAAA;EACA,gCAAA;EACA,2BAAA;EACA,0BAAA;EACA,eAAA;EACA,uBAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAwtBR;;AAptBE;EACE,yBAAA;EACA,2BAAA;EACA,mBAAA;EACA,6BAAA;AAutBJ;;AArtBE;EACE,uBAAA;AAwtBJ;;AAttBE;EACE,mBAAA;AAytBJ;;AAvtBE;EACE,oCAAA;AA0tBJ;;AAxtBE;EACE,sCAAA;AA2tBJ;;AAztBE;EACE,sBAAA;EACA,gBAAA;EACA,kBAAA;AA4tBJ;;AA1tBE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;AA6tBJ;;AA1tBE;EACE,UAAA;EACA,QAAA;EACA,SAAA;AA6tBJ;;AA1tBA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EAEA,gBAAA;AA6tBF;;AA1tBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EAEA,gBAAA;AA6tBF;;AA1tBA;EACE,gCAAA;AA6tBF;;AA1tBA;EACE,kCAAA;AA6tBF;;AA1tBA;EAGE,2BAAA;AA6tBF;;AA1tBA,oBAAA;AACA;EACE,mBAAA;AA6tBF;;AA1tBA;EACE,kBAAA;AA6tBF;;AA3tBA;EACE,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;EACA,iCAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;AA8tBF;AA7tBE;EACE,2BAAA;EACE,wBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;AA+tBN;;AA5tBA;EAEE;IACE,wBAAA;IACA,iCAAA;IACA,sBAAA;EA8tBF;EA7tBE;IACE,sBAAA;IACA,uBAAA;IACA,0BAAA;IACA,2BAAA;EA+tBJ;EA5tBI;IACE,gCAAA;EA8tBN;EAztBI;IACE,uBAAA;EA2tBN;EAxtBI;IACE,uBAAA;IACA,6BAAA;IACA,8BAAA;IACA,6BAAA;EA0tBN;AACF;AArtBA;EACE,8BAAA;AAutBF;AAttBE;EACE,gBAAA;AAwtBJ;AAvtBI;EACE,yBAAA;EACA,2BAAA;EACA,gBAAA;AAytBN;;AAptBA;EACE,0BAAA;EACA,6BAAA;AAutBF;;AAntBI;EACE,2BAAA;AAstBN;;AAjtBQ;EACI,mBDvSN;AC2/BN;AAltBY;EACI,eDxbR;ECybQ,cAAA;AAotBhB","sourcesContent":["/*--Fonts--*/\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');\n\n:root {\n  --primary: #FF914E;\n  --secondary: #07748F;\n  --info: #343833;\n  --white: #FFFFFF;\n  --black: #000000;\n  --liteblue: #e7f3f5;\n  --shadeblue: #d1e6eb;\n  --hrborder: #e4dede;\n  --theader: #f5f7f8;\n  --thinfo: #384648;\n  --thborder: #dee2e6;\n  --dlink: #007bff;\n  --btninfo: #313232;\n  --gary: #5a6e82;\n  --high-to-low: linear-gradient(to right, #07748F 0%, #72B0C0 100%);\n  --low-to-high: linear-gradient(90deg, #72B0C0 0, #07748F);\n  --red: #f15e48;\n  --green: #02681a;\n  --lowgray: #A0B2B5;\n}\n\n/* ---- font family ----*/\n$montserrat : 'Montserrat';\n$roboto: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n\n/*--- pixels --- */\n$px-0: 0px;\n$px-1: 1px;\n$px-2: 2px;\n$px-3: 3px;\n$px-4: 4px;\n$px-5: 5px;\n$px-6: 6px;\n$px-7: 7px;\n$px-8: 8px;\n$px-9: 9px;\n$px-10: 10px;\n$px-11: 11px;\n$px--11: -11px;\n$px-12: 12px;\n$px-13: 13px;\n$px-14: 14px;\n$px-15: 15px;\n$px-16: 16px;\n$px-17: 17px;\n$px-18: 18px;\n$px-19: 19px;\n$px-20: 20px;\n$px-21: 21px;\n$px-22: 22px;\n$px-23: 23px;\n$px-24: 24px;\n$px-25: 25px;\n$px-26: 26px;\n$px-27: 27px;\n$px-28: 28px;\n$px-29: 29px;\n$px-30: 30px;\n$px-31: 31px;\n$px-32: 32px;\n$px-33: 33px;\n$px-34: 34px;\n$px-35: 35px;\n$px-36: 36px;\n$px-37: 37px;\n$px-38: 38px;\n$px-39: 39px;\n$px-40: 40px;\n$px-41: 41px;\n$px-42: 42px;\n$px-43: 43px;\n$px-44: 44px;\n$px-45: 45px;\n$px-46: 46px;\n$px-47: 47px;\n$px-48: 48px;\n$px-49: 49px;\n$px-50: 50px;\n$px-51: 51px;\n$px-52: 52px;\n$px-53: 53px;\n$px-54: 54px;\n$px-55: 55px;\n$px-56: 56px;\n$px-57: 57px;\n$px-58: 58px;\n$px-59: 59px;\n$px-60: 60px;\n$px-61: 61px;\n$px-62: 62px;\n$px-63: 63px;\n$px-64: 64px;\n$px-65: 65px;\n$px-70: 70px;\n$px-74: 74px;\n$px-75: 75px;\n$px-80: 80px;\n$px-85: 85px;\n$px-100: 100px;\n$px-115: 115px;\n$px-120: 120px;\n$px-124: 124px;\n$px-130: 130px;\n$px-150: 150px;\n$px-200: 200px;\n$px-226: 226px;\n$px-250: 250px;\n$px-280: 280px;\n$px-300: 300px;\n$px-585: 585px;\n\n/*---font size---*/\n$f-10: $px-10;\n$f-11: $px-11;\n$f-12: $px-12;\n$f-13: $px-13;\n$f-14: $px-14;\n$f-15: $px-15;\n$f-16: $px-16;\n$f-17: $px-17;\n$f-18: $px-18;\n$f-19: $px-19;\n$f-20: $px-20;\n$f-21: $px-21;\n$f-22: $px-22;\n$f-23: $px-23;\n$f-24: $px-24;\n$f-25: $px-25;\n$f-26: $px-26;\n$f-27: $px-27;\n$f-28: $px-28;\n$f-29: $px-29;\n$f-30: $px-30;\n$f-31: $px-31;\n$f-32: $px-32;\n$f-33: $px-33;\n$f-34: $px-34;\n$f-35: $px-35;\n$f-36: $px-36;\n$f-37: $px-37;\n$f-38: $px-38;\n$f-39: $px-39;\n$f-40: $px-40;\n$f-41: $px-41;\n$f-42: $px-42;\n$f-43: $px-43;\n$f-46: $px-46;\n\n/*---font weight---*/\n$f-300: 300;\n$f-400: 400;\n$f-500: 500;\n$f-600: 600;\n$f-700: 700;\n$f-800: 800;\n$f-900: 900;\n\n/*--- percentage ---*/\n$per-8: 8%;\n$per-10: 10%;\n$per-18: 18%;\n$per-30: 30%;\n$per-35: 35%;\n$per-38: 38%;\n$per-40: 40%;\n$per-45: 45%;\n$per-48: 48%;\n$per-50: 50%;\n$per-55: 55%;\n$per-60: 60%;\n$per-85: 85%;\n$per-90: 90%;\n$per-91: 91%;\n$per-100: 100%;\n$per-200: 200%;\n\n/*--- display ---*/\n$flex: flex;\n$block: block;\n$grid: grid;\n$auto: auto;\n$inlineblock: inline-block;\n$row: row;\n$none: none;\n$max-content: max-content;\n$transparent: transparent;\n$no-repeat: no-repeat;\n\n/*--- alignment ---*/\n$top: top;\n$left: left;\n$center: center;\n$right: right;\n$bottom: bottom;\n$middle: middle;\n$space-between: space-between;\n$column: column;\n$breakword: break-word;\n$borderbox: border-box;\n$end: end;\n\n/*--Position --*/\n$relative: relative;\n$absolute: absolute;\n$initial: initial;\n\n/*--- Text Transform ---*/\n$uppercase: uppercase;\n$lowercase: lowercase;\n$capitalize: capitalize;\n$underline: underline;\n\n/*-- Text Style --*/\n$normal: normal;\n\n/*-- Info and paragraph --*/\n.font-common {\n  font-size: $f-14;\n  color: var(--info);\n  font-weight: $f-600;\n}\n\n/*--Flex-box--*/\n.w-flex {\n  width: $per-100;\n  display: $flex;\n}\n\n/*-- Form Label--*/\n.input-fonts {\n  font-size: $f-11;\n  color: var(--black);\n}\n\n.formlabel {\n  @extend .input-fonts;\n  opacity: 1;\n  margin-bottom: 0.3rem;\n  margin-top: $px-5;\n  font-weight: $f-500;\n}\n\n.login-btn-hover {\n  color: var(--primary);\n  background-position: $left;\n  fill: var(--primary) !important;\n}\n\n.heading-comman {\n  font-style: $normal;\n  font-weight: 700;\n}\n\n.heading-1 {\n  font-size: $f-43;\n  line-height: $px-62;\n  margin-bottom: $px-25;\n  @extend .heading-comman;\n}\n\n.heading-2 {\n  font-size: $f-35;\n  line-height: $px-50;\n  @extend .heading-comman;\n}\n\n.heading-3 {\n  font-size: $f-30;\n  line-height: $px-60;\n  margin-bottom: $px-15;\n  @extend .heading-comman;\n}\n\n.heading-4 {\n  font-weight: 600;\n  font-size: 25px;\n  line-height: 26px;\n  @extend .heading-comman;\n}\n\n.inputfields {\n  @extend .input-fonts;\n  height: $px-30;\n  line-height: $px-30;\n  opacity: .8;\n  padding: $px-0 0.5rem;\n  background: #F4F6F7;\n}\n\n/*-- Box outer --*/\n.boxing {\n  position: $relative;\n  display: $flex;\n  flex-direction: $column;\n  min-width: 0;\n  word-wrap: $breakword;\n  background-color: var(--white);\n  background-clip: $borderbox;\n  border: $px-1 solid rgba(0, 0, 0, .125);\n  border-radius: 0.25rem;\n  box-shadow: 0 .125rem .25rem rgba(0, 0, 0, .075);\n  padding: $px-15 $px-15;\n}\n\n.login-btn-hover {\n  color: var(--primary);\n  background-position: $left;\n  fill: var(--primary) !important;\n}\n\n.heading-comman {\n  font-style: $normal;\n  font-weight: 700;\n}\n\n.heading-1 {\n  font-size: $f-43;\n  line-height: $px-62;\n  margin-bottom: $px-25;\n  @extend .heading-comman;\n}\n\n.heading-2 {\n  font-size: $f-35;\n  line-height: $px-50;\n  @extend .heading-comman;\n}\n\n.heading-3 {\n  font-size: $f-30;\n  line-height: $px-60;\n  margin-bottom: $px-15;\n  @extend .heading-comman;\n}\n\n/*--Buttons common--*/\n.button-common {\n  background: $transparent  !important;\n  display: $inlineblock  !important;\n  padding: $px-8 $px-30  !important;\n  height: $px-44  !important;\n  border-radius: $px-50  !important;\n  position: $relative  !important;\n  transition: all .5s linear !important;\n  text-align: $center  !important;\n  vertical-align: $middle  !important;\n  text-decoration: $none  !important;\n  outline: $px-0  !important;\n  font-size: $f-16  !important;\n  font-weight: $f-600  !important;\n  line-height: $px-0  !important;\n  cursor: pointer !important;\n  text-transform: $capitalize  !important;\n}\n\n.link_button {\n  padding: $px-8 $px-40  !important;\n  line-height: 1.5 !important;\n  height: fit-content !important;\n}\n\n.primary {\n  border: $px-3 solid var(--primary) !important;\n  background-color: var(--primary) !important;\n  color: var(--white) !important;\n  box-shadow: none!important;\n}\n\n.secondary {\n  border: $px-3 solid var(--primary) !important;\n  background-color: var(--primary) !important;\n  color: var(--white) !important;\n  box-shadow: none!important;\n}\n.stepper-next-btn:hover {\n  border: 0px !important;\n}\n\n.primary_button {\n  @extend .button-common;\n  @extend .primary;\n\n  &:hover {\n    @extend .secondary;\n  }\n\n  span.MuiTouchRipple-root {\n    display: none;\n  }\n}\n\n.secondary_button {\n  @extend .button-common;\n  @extend .secondary;\n\n  &:hover {\n    @extend .primary;\n  }\n\n  span.MuiTouchRipple-root {\n    display: none;\n  }\n}\n.seeanalytics {\n  padding: 8px 18px!important;\n  font-size: 13px!important;\n  font-weight: 500!important;\n  height: 33px!important;\n  &:hover, &:active, &:focus {\n    background-color: var(--primary)!important;\n  }\n}\n\n.btn-wid {\n  padding: 10px 40px !important;\n  margin-top: 25px;\n  margin-right: 13px;\n}\n\n/* --banner-style-- */\n.banner-bg-content {\n  .banner-container {\n    padding-top: $px-30;\n    padding-bottom: $px-30;\n    min-height: 585px;\n\n    .banner-content {\n      padding: $px-0;\n      color: var(--white);\n      font-style: $normal;\n\n      .smalltext {\n        font-weight: 600 !important;\n        line-height: 68px !important;\n        color: #07748f !important;\n        margin-bottom: 0 !important;\n        margin-top: 17px !important;\n        @extend .heading-2;\n      }\n\n      h1 {\n        @extend .heading-1;\n      }\n\n      p {\n        font-weight: $f-400;\n        font-size: $f-20;\n        line-height: $px-30;\n        margin-bottom: 1rem;\n      }\n    }\n\n    .banner-img {\n      img {\n        width: 119%;\n        position: $relative;\n        top: -$px-10;\n        left: 74px;\n        height: $auto;\n      }\n    }\n\n    .banner-btn {\n      a {\n        @extend .link_button;\n        box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3);\n\n        &:nth-child(2) {\n          background-color: $transparent  !important;\n          border: 2px solid var(--white) !important;\n        }\n\n        @extend .btn-wid;\n        @extend .primary_button;\n\n        &:hover {\n          box-shadow: $none;\n        }\n      }\n    }\n  }\n}\n\n/* -- card-style -- */\n.card-content {\n  background-color: rgba(7, 116, 143, .05);\n\n  h4 {\n    margin-bottom: $px-40;\n    @extend .heading-2;\n  }\n\n  .section-card {\n    width: $per-100;\n    margin-left: $auto;\n    display: $block;\n    height: 105px;\n    background: var(--white);\n    box-shadow: 0 4px 20px rgba(23, 125, 150, .2);\n    border-radius: $px-20;\n    padding: 10px 18px 10px 6px;\n    margin-bottom: $px-25;\n    transition: all .5s ease-in-out;\n    flex-direction: unset !important;\n\n    p {\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 22px;\n      margin-bottom: 0;\n      margin-left: 10px;\n    }\n\n    &:hover {\n      transform: scale(1.05);\n      box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3) !important;\n    }\n  }\n}\n\n  .btn-wid {\n    padding: 10px 40px !important;\n    margin-top: 25px;\n    margin-right: 13px;\n  }\n\n  /* --banner-style-- */\n  .banner-bg-content {\n    .banner-container {\n      padding-top: $px-30;\n      padding-bottom: $px-30;\n      min-height: 585px;\n\n      .banner-content {\n        padding: $px-0;\n        color: var(--white);\n        font-style: $normal;\n\n        .smalltext {\n          font-weight: 600 !important;\n          line-height: 68px !important;\n          color: #07748f !important;\n          margin-bottom: 0 !important;\n          margin-top: 17px !important;\n          @extend .heading-2;\n        }\n\n        h1 {\n          @extend .heading-1;\n        }\n\n        p {\n          font-weight: $f-400;\n          font-size: $f-20;\n          line-height: $px-30;\n          margin-bottom: 1rem;\n        }\n      }\n\n      .banner-img {\n        img {\n          width: 119%;\n          position: $relative;\n          top: -$px-10;\n          left: 74px;\n          height: $auto;\n        }\n      }\n\n      .banner-btn {\n        a {\n          @extend .link_button;\n          box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3);\n\n          &:nth-child(2) {\n            background-color: $transparent  !important;\n            border: 2px solid var(--white) !important;\n          }\n\n          @extend .btn-wid;\n          @extend .primary_button;\n\n          &:hover {\n            box-shadow: $none;\n          }\n        }\n      }\n    }\n  }\n\n  /* -- card-style -- */\n  .card-comman {\n    background: #fff;\n    box-shadow: 0 4px 40px rgba(0, 0, 0, .1);\n    border-radius: 20px;\n  }\n\n  .card-content {\n    background-color: rgba(7, 116, 143, .05);\n\n    h4 {\n      margin-bottom: $px-40;\n      @extend .heading-2;\n    }\n\n    .section-card {\n      width: $per-100;\n      margin-left: $auto;\n      display: $block;\n      height: 105px;\n      background: var(--white);\n      box-shadow: 0 4px 20px rgba(23, 125, 150, .2);\n      border-radius: $px-20;\n      padding: 10px 18px 10px 6px;\n      margin-bottom: $px-25;\n      transition: all .5s ease-in-out;\n      flex-direction: unset !important;\n\n      .h-op-features {\n        font-weight: 600 !important;\n        margin-bottom: 5px !important;\n      }\n\n      p {\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 22px;\n        margin-bottom: 0;\n        margin-left: 10px;\n      }\n\n      &:hover {\n        transform: scale(1.05);\n        box-shadow: 0 5px 15px 1.5px rgba(255, 145, 78, .3) !important;\n      }\n    }\n  }","@import \"../../../style.scss\";\n@import \"../searchform.scss\";\n\n.addmarket {\n    h1,\n    p {\n        margin-bottom: $px-8;\n        line-height: 1.2;\n    }\n\n    .MuiGrid-grid-xs-2 {\n        display: $flex !important;\n        justify-content: flex-start !important;\n    }\n    @extend .fr-to-search;\n}\n\n.font-p {\n    font-size: $f-12 !important;\n    font-weight: $f-500;\n}\n/*-- Stepper --*/\n.shop-stepper {\n    .MuiStepIcon-completed-cx svg circle {\n      fill: var(--primary) !important;\n    }\n    .MuiStep-root:nth-child(2) .MuiStepConnector-root.Mui-active .MuiStepConnector-lineHorizontal,\n    .MuiStep-root:nth-child(2) .MuiStepConnector-root.Mui-completed .MuiStepConnector-lineHorizontal, \n    .MuiStep-root:nth-child(3) .MuiStepConnector-root.Mui-active .MuiStepConnector-lineHorizontal  {\n      border-color: var(--primary);\n    }\n    .MuiStepIcon-completed-cx svg text {\n      fill: var(--white) !important;\n    }\n  \n    .MuiStepIcon-completed-cx .MuiStepLabel-alternativeLabel {\n      color: rgba(0, 0, 0, .87) !important;\n      @extend .font-p;\n    }\n  \n    .MuiStepLabel-root .MuiStepLabel-alternativeLabel svg.MuiSvgIcon-root {\n      width: $px-33;\n      height: $px-33 !important;\n      background: var(--primary);\n      border-radius: $per-50;\n      margin: 0;\n      border: $px-2 solid var(--primary);\n      color: var(--white);\n    }\n  \n    .MuiStepIcon-root.MuiStepIcon-active {\n      color: var(--primary);\n    }\n  \n    .MuiStepIcon-root.MuiStepIcon-active text {\n      fill: var(--white);\n    }\n  \n    .MuiStepIcon-root.MuiStepIcon-active circle {\n      fill: var(--primary);\n    }\n  \n    svg text.MuiStepIcon-text {\n     @extend .font-p;\n      fill: var(--primary);\n    }\n  \n    .MuiStepConnector-lineHorizontal {\n      border-top-width: $px-6;\n      margin-top: $px-2;\n      border-color: #fdeeec;\n      z-index: 0;\n    }\n  \n    .MuiStepConnector-alternativeLabel {\n      top: $px-11;\n      left: calc(-50% + 8px);\n      right: calc(50% + 8px);\n    }\n  \n    .MuiStepLabel-iconContainer {\n      z-index: 1;\n    }\n  \n    .Mui-disabled {\n      svg circle {\n        fill: var(--white);\n      }\n  \n      svg text {\n        fill: var(--primary);\n        @extend .font-p;\n      }\n    }\n  \n    .MuiStepIcon-root.MuiStepIcon-completed {\n      color: var(--primary);\n    }\n  \n    .MuiStepConnector-active, .MuiStepConnector-completed {\n      .MuiStepConnector-lineHorizontal {\n        border-color: var(--primary);\n      }\n    }\n  \n    .MuiStepLabel-label.MuiStepLabel-alternativeLabel {\n        @extend .font-p;\n      font-size: $f-15!important;\n      margin-top: $px-5;\n    }\n\n    .MuiStepper-root {\n        display: $flex;\n        padding: $px-0 $px-24 $px-24;\n    }\n  \n    .Mui-disabled {\n      .MuiStepLabel-labelContainer {\n        .MuiStepLabel-alternativeLabel {\n          color: var(--black);\n          opacity: 0.5;\n        }\n      }\n    }\n  }\n  \n  /*-- Stepper Common Values --*/\n  .addmarketstepper {\n    form {\n        padding: $px-0 $px-7;\n        .MuiGrid-root {\n        p.MuiFormHelperText-root {\n          font-size: $px-11!important;\n        }\n      }\n    }\n    label.MuiFormLabel-root {\n        font-size: $f-13;\n        font-weight: $f-500;\n        color: #212529;\n        line-height: 1.5;\n    }\n    .checkbox-input {\n      .MuiFormGroup-root {\n        label.MuiFormControlLabel-root {\n          margin-bottom: 0.5em;\n          span.MuiButtonBase-root {\n            padding: $px-0;\n          }\n          span.MuiTypography-root {\n            font-weight: $f-400;\n            color: #7b7b7b;\n            font-size: $f-13;\n            margin-left: $px-5;\n          }\n        }\n        label.MuiFormControlLabel-root.Mui-disabled {\n          .MuiCheckbox-root {\n            opacity: 0.5;\n            cursor: no-drop;\n          }\n        }\n      }\n  }\n  }\n  .stepper-btn {\n    justify-content: $space-between;\n    display: $flex;\n    button.secondary_button.clear-background {\n      background: $transparent!important;\n      color: #313232!important;\n      border: $px-1 solid #313232!important;\n      margin-right: $px-15!important;\n    }\n  }\n  .stepper-first-btn {\n    justify-content: $end;\n  }\n  .flightshopdetails, .stepper-btn {\n    .secondary_button {\n      border-radius: $px-2  !important;\n      height: $px-33  !important;\n      line-height: $px-33  !important;\n      font-size: $px-14  !important;\n      padding: $px-0 $px-35!important;\n      font-weight: $f-400!important;\n      border: $px-0!important;\n  }\n  }\n  .searchinput-box {\n    width: 280px;\n    height: calc(1.5em + 0.5rem + 2px);\n    padding: $px-5 $px-10;\n    font-weight: $f-300;\n    font-size: $f-13;\n    border: $px-1 solid #aaa;\n    border-radius: $px-4;\n    margin: $px-1 $px-10 $px-12 $px--11;\n    background: #F4F6F7;\n  }\n  .source-dropdown {\n    .MuiFormGroup-root, .check-field-box {\n      width: 85%;\n      overflow-y: auto;\n      max-height: 200px;\n      margin-left: -10px;\n      flex-wrap: nowrap;\n      padding: 5px 7px;\n      border: 1px solid #d9d9d9;\n      border-radius: 5px;\n      margin-bottom: 12px;\n    label.MuiFormControlLabel-root {\n      margin-left: 0px!important;\n    }\n  }\n  }\n  .select-box-stepper{\n    .MuiFormControl-root{\n      width: 95%;\n      margin-top: 0px !important;\n      margin-bottom: 0px !important;\n      .css-1yk1gt9-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root{\n        width: 100%;\n      }\n    }\n    .MuiSelect-select, .select-dropdown {\n      height: 33px;\n      color: #7b7b7b;\n      padding: 0.2rem 0.75rem;\n      width: 95%;\n      font-size: 13px!important;\n      box-shadow: none!important;\n      border: 1px solid #ced4da!important;\n      border-radius: 0.2rem;\n      text-transform: none !important;\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      span{\n        svg{\n          margin-top: 5px !important;\n        }\n      }\n    }\n  }\n  .volatility-airline{\n    .css-3dzjca-MuiPaper-root-MuiPopover-paper-MuiMenu-paper, .MuiMenu-paper {\n      width: 15%;\n      ul{\n        li{\n          span{\n            margin-right: 5px !important;\n          }\n          .MuiListItemText-root{\n            span{\n              font-size: 11px !important;\n              font-weight: 500 ;\n              word-break: break-all;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .check-field-box{\n    .MuiFormHelperText-root{\n      margin-bottom: 0px !important;\n      margin-left: 0.7rem;\n    }\n    p{\n      margin-bottom: 1rem !important;\n      .learnmore-link{\n        margin-left: 0.7rem;\n    font-size: 11px;\n    text-decoration: underline;\n      }\n    }\n  }\n  .num-stop-box{\n    display: flex;\n    align-items: center;\n    input{\n      margin-right: 2px;\n\n    }\n    label{\n      margin-left: 5px;\n      margin-right: 15px ;\n    }\n  }\n  .switch-button {\n    display: inline-block;\n    position: relative;\n    top: -6px;\n    margin-right: 10px;\n    label {\n      // background-color: #FF914E;\n      // border: 2px solid #FF914E;\n      // border-radius: 3px;\n      // margin-bottom: 0px;\n      display: flex;\n      align-items: center;\n      svg {\n        color: #fff;\n        position: relative;\n        left: -1px;\n      }\n      i {\n        color: #fff!important;\n        text-decoration: none!important;\n        font-weight: 500!important;\n        cursor: pointer!important;\n        font-size: 13px;\n        background: transparent;\n        border: none;\n        outline: 0px;\n        padding: 5px 5px 5px 5px;\n        font-style: normal;\n        position: relative;\n        top: -1px;\n      }\n    }\n  }\n  #swtoggle label i{\n    color: #7B7B7B !important;\n    font-weight: 400 !important;\n    top: 7px !important;\n    padding-left: 10px !important;\n  }\n  #swtoggle .backgroundset {\n    padding: 0px !important;\n  }\n  #swtoggle .switch {\n    top: 7px !important;\n  }\n  #swtoggle input:checked + .slider{\n    background-color: #FF914E !important;\n  }\n  #swtoggle input:focus + .slider {\n    box-shadow: 0 0 1px #FF914E !important;\n  }\n  .backgroundset {\n    background-color: #fff;\n    padding: 2px 3px;\n    border-radius: 2px;\n  }\n  .switch {\n    position: relative;\n    display: inline-block;\n    width: 34px;\n    height: 18px;\n    top: 3px;\n  }\n  \n  .switch input { \n    opacity: 0;\n    width: 0;\n    height: 0;\n  }\n  \n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgb(136, 136, 136);\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 14px;\n  width: 14px;\n  left: 2px;\n  bottom: 2px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\ninput:checked + .slider {\n  background-color: rgb(0, 136, 0);\n}\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px rgb(0, 136, 0);\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(16px);\n  -ms-transform: translateX(16px);\n  transform: translateX(16px);\n}\n\n/* Rounded sliders */\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n.btn-swap-css {\n  display: flex!important;\n  align-items: center;\n  justify-content: center;\n  text-align: center!important;\n  vertical-align: middle!important;\n  height: 37px!important;\n  line-height: 37px!important;\n  cursor: pointer;\n  svg {\n    margin-top: -3px!important;\n      height: 0.9em!important;\n      line-height: 37px!important;\n      display: block!important;\n      color: #fff!important;\n  }\n}\n@media (min-width: 280px) and (max-width: 991.5px) {\n\n  #createMmarketResponsive{\n    display: flex !important;\n    flex-direction: column !important;\n    margin: 0px !important;\n    .MuiGrid-grid-xs-3, .MuiGrid-grid-xs-2, .MuiGrid-grid-xs-1{\n      width: 100% !important;\n      padding: 0px !important;\n      max-width: 100% !important;\n      flex-basis: 100% !important;\n    }\n    .from-input-filed, .to-input-filed{\n      .MuiTextField-root{\n        padding: 0px 0px 10px!important;\n      }\n    }\n    \n    .MuiGrid-grid-xs-1 {\n      button{\n        margin: auto !important;\n\n      }\n      .btn-swap-css{\n        margin: auto !important;\n        margin-right: auto !important;\n        margin-bottom: 10px !important;\n        width: fit-content !important;\n      }\n    }\n  }\n\n}\n.rate-parity-label{\n  margin-bottom: 15px !important;\n  label{\n    margin-left: 0px;\n    .MuiTypography-root{\n      color: #212529 !important;\n      font-weight: 500 !important;\n      line-height: 1.5;\n    }\n  }\n}\n\n.MuiTextField-root{\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n}\n#createMmarketResponsive{\n  .MuiFormControl-root{\n    input {\n      padding: 0px 8px !important;\n    }\n  }\n}\n    .flex-radiobox {\n        .MuiFormGroup-root {\n            flex-direction: $row;\n\n            .MuiTypography-root {\n                font-size: $f-13;\n                color: #7b7b7b;\n            }\n        }\n    }\n\n","@import \"../../style.scss\";\n\n/* search route base form style */\n.fr-to-search {\n    padding: 1.25rem;\n    p {\n        @extend .font-common;\n        font-weight: $f-500;\n        margin-bottom: $px-10;\n    }\n    .MuiGrid-grid-xs-3 {\n        .MuiFormControl-root {\n            width: 100%;\n            padding-right: $px-17;\n            input {\n                @extend .inputfields;\n                font-size: $px-13;\n                height: $px-35;\n                border: 1px solid #d9d9d9 !important;\n                border-radius: 4px;\n            }\n        }\n    }\n    button, button.secondary_button {\n        border-radius: $px-3!important;\n        font-size: $f-14!important;\n        font-weight: $f-400!important;\n        height: $px-37!important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
